import { z } from 'zod';

import { createPasswordSchema } from '../../config/password-schema';

export const profileFormSchema = z.object({
  displayName: z.string().trim().max(100, 'Name must be less than 100 characters'),
  photoURL: z
    .string()
    .trim()
    .refine(val => !val || val.startsWith('http://') || val.startsWith('https://'), {
      message: 'Photo URL must start with http:// or https://',
    })
    .optional()
    .or(z.literal('')),
});

export type ProfileFormData = z.infer<typeof profileFormSchema>;

export const profilePasswordFormSchema = z
  .object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: createPasswordSchema(),
    confirmPassword: z.string(),
  })
  .superRefine((data, ctx) => {
    // Validate passwords match
    if (data.newPassword !== data.confirmPassword) {
      ctx.addIssue({
        code: 'custom',
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      });
    }
    // Validate new password differs from current
    if (data.currentPassword === data.newPassword) {
      ctx.addIssue({
        code: 'custom',
        message: 'New password must be different from current password',
        path: ['newPassword'],
      });
    }
  });

export type ProfilePasswordFormData = z.infer<typeof profilePasswordFormSchema>;

export const addPasswordSchema = z
  .object({
    newPassword: createPasswordSchema(),
    confirmPassword: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.newPassword !== data.confirmPassword) {
      ctx.addIssue({
        code: 'custom',
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      });
    }
  });

export type AddPasswordFormData = z.infer<typeof addPasswordSchema>;

// Pattern: docs/design-patterns/frontend/form-handling.md
export const flowStyleSchema = z.object({
  flowStyle: z.enum(['hands_free', 'planning_gate', 'implementation_gate', 'guided']),
});

export type FlowStyleFormData = z.infer<typeof flowStyleSchema>;
